/**
 * Premium Upgrade Pending Page
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, Home, User } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';

const PremiumPending = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <Card className="bg-gray-800 border-gray-700 max-w-md w-full">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4 w-20 h-20 bg-yellow-500/20 rounded-full flex items-center justify-center">
            <Clock className="w-12 h-12 text-yellow-500" />
          </div>
          <CardTitle className="text-2xl text-white">Pago pendiente</CardTitle>
          <CardDescription className="text-gray-400">
            Tu pago está siendo procesado
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6">
          <div className="text-center text-gray-400 text-sm">
            <p>Algunos métodos de pago pueden tardar hasta 72 horas en confirmarse.</p>
            <p className="mt-2">Te notificaremos por correo cuando tu Premium sea activado.</p>
          </div>
          
          <div className="flex flex-col gap-3">
            <Button
              onClick={() => navigate('/profile')}
              className="w-full bg-[#7ED957] hover:bg-[#6bc548] text-black font-bold"
            >
              <User className="w-4 h-4 mr-2" />
              Ver mi perfil
            </Button>
            <Button
              onClick={() => navigate('/home')}
              variant="outline"
              className="w-full border-gray-600 text-gray-300 hover:bg-gray-700"
            >
              <Home className="w-4 h-4 mr-2" />
              Volver al inicio
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PremiumPending;
